import React from "react";
import { Link } from "react-router-dom";

const COMPANY = {
  name: "Wintercove Investments",
  address1: "1864 West 1st Avenue",
  address2: "Vancouver, Canada",
  phone: "+1 (604) 908-4578",
  phoneHref: "tel:+16049084578",
  emails: [
    { addr: "Nicholas@wintercove.com", testid: "footer-email-nicholas-link" },
    { addr: "Tessa@wintercove.com", testid: "footer-email-tessa-link" },
  ],
};

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1f3a2e] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-flex items-center justify-center w-10 h-10 border hairline-dark">
                <span className="font-serif-display text-xl">W</span>
              </span>
              <span className="font-serif-display text-[22px] tracking-tight">
                Wintercove Investments Limited
              </span>
            </div>
            <p className="text-white/70 text-base leading-relaxed max-w-md font-light">
              Wintercove Investments.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-white/60 mb-4">Office</p>
            <address className="not-italic text-white/85 text-[15px] leading-relaxed font-light" data-testid="footer-address">
              {COMPANY.address1}<br />
              {COMPANY.address2}
            </address>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-white/60 mb-4">Contact</p>
            <ul className="space-y-2 text-[15px] font-light">
              <li>
                <a
                  href={COMPANY.phoneHref}
                  data-testid="footer-phone-link"
                  className="text-white/85 hover:text-white transition-colors"
                >
                  {COMPANY.phone}
                </a>
              </li>
              {COMPANY.emails.map((e) => (
                <li key={e.addr}>
                  <a
                    href={`mailto:${e.addr}`}
                    data-testid={e.testid}
                    className="text-white/85 hover:text-white transition-colors"
                  >
                    {e.addr}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-10 border-t hairline-dark" data-testid="rhea-note">
          <p className="eyebrow text-white/60 mb-4">Wintercove Public Relations</p>
          <p className="text-white/75 text-[14px] leading-relaxed font-light max-w-3xl">
            <a
              href="https://wintercove.com/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="rhea-website-link"
              className="text-white underline-offset-4 hover:underline"
            >
              wintercove.com
            </a>
          </p>
        </div>

        <div className="mt-16 pt-10 border-t hairline-dark">
          <p className="eyebrow text-white/60 mb-5">Disclosures</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-[13px] text-white/60 leading-relaxed font-light">
            <p data-testid="disclosure-offer">
              This site does not constitute an offer to sell, or a solicitation of
              an offer to buy, any security. Offers are made only by definitive
              offering documents to qualified investors.
            </p>
            <p data-testid="disclosure-performance">
              Past performance is not indicative of future results. Investments
              involve risk, including possible loss of principal.
            </p>
            <p data-testid="disclosure-privacy">
              By submitting an inquiry, you agree to our{" "}
              <Link to="#" className="underline-offset-4 hover:underline">Privacy Policy</Link>{" "}
              and{" "}
              <Link to="#" className="underline-offset-4 hover:underline">Terms</Link>.
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-white/50 text-[12px] tracking-wide">
            © {new Date().getFullYear()} Wintercove Investments. All rights reserved.
          </p>
          <p className="text-white/40 text-[12px] tracking-wide">
            Vancouver, Canada
          </p>
        </div>
      </div>
    </footer>
  );
}
